import { Component, OnInit, PipeTransform } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, Subject } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DecimalPipe } from '@angular/common';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

function search(text: string): Category[] {
	return CATEGORIES.filter((country) => {
		const term = text.toLowerCase();
		return country.name.toLowerCase().includes(term);
	});
}

interface Category {
	id:number,
	name: string,
	forumCount: number
}

const CATEGORIES: Category[] = [];

@Component({
	selector: 'app-admin-forum-categories',
	templateUrl: './admin-forum-categories.component.html',
	styleUrls: ['./admin-forum-categories.component.scss'],
})
export class AdminForumCategoriesComponent implements OnInit {
	// countries$: Subject<Country[]> =new Subject();
	categories: Array<any>;
	category: any = {};
	filter = new FormControl('');
    private modalRef: any;

	/**
	 * Constructor
	 */
	constructor(
		// private modalService: NgbModal,
		private toastr: ToastrService,
		// private local: LocalServiceService,
		private auth: AuthServiceService,
		private fb: FormBuilder,
		private spinner: NgxSpinnerService,
        private modalService: NgbModal,
	) {
		// this.countries$ = this.filter.valueChanges.pipe(
		// 	startWith(''),
		// 	map((text) => search(text)),
		// );

		this.categories = CATEGORIES;
	}

	ngOnInit(): void {
		this.initCategories()
	}


    initCategories() {
        this.auth.forum_category_fetch().subscribe((response: any) => {
            this.categories = response.body
        })
    }

	openForm(modal: any, category: any = {}){
        this.modalService.dismissAll()
        this.modalRef = this.modalService.open(modal, { size: 'sm', ariaLabelledBy: 'modal-basic-title', windowClass: 'form_modal' })
		this.category = category
	}

	categoryStore() {
		if(!this.category.name) {
			return alert("Please fill the name of Category")
		}

		this.auth.forum_category_store(this.category).subscribe((response:any) => {
			this.initCategories()
			this.modalService.dismissAll()
		})
	}

	deleteCategory(id:any) {
		const getConfirm = confirm("are you sure ?")

		if(getConfirm)
			this.auth.forum_category_delete(id).subscribe((response:any) => {
				alert("Forum Category has been deleted")
				this.initCategories()
			})
	}

}
